// 🧪 Workshop API Test Utilities
// Use these functions in browser console to test workshop functionality

/**
 * Test participant removal endpoint
 * @param {string} workshopId - Workshop ID
 * @param {string} userId - User ID to remove (use participant.user._id)
 * @param {string} reason - Reason for removal
 */
export const testRemoveParticipant = async (
  workshopId,
  userId,
  reason = "Test removal"
) => {
  const token =
    localStorage.getItem("authToken") || localStorage.getItem("token");

  if (!token) {
return;
  }
try {
    const response = await fetch(
      `/api/workshops/${workshopId}/participants/${userId}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ reason }),
      }
    );

    const data = await response.json();
if (!response.ok) {
      throw new Error(
        `HTTP ${response.status}: ${data.message || "Unknown error"}`
      );
    }
return data;
  } catch (error) {
throw error;
  }
};

/**
 * Test workshop details endpoint to check userRole object
 * @param {string} workshopId - Workshop ID
 */
export const testWorkshopUserRole = async (workshopId) => {
  const token =
    localStorage.getItem("authToken") || localStorage.getItem("token");

  if (!token) {
return;
  }
try {
    const response = await fetch(`/api/workshops/${workshopId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
if (!response.ok) {
      throw new Error(
        `HTTP ${response.status}: ${data.message || "Unknown error"}`
      );
    }

    const workshop = data.data?.workshop;
    if (workshop) {
}

    return data;
  } catch (error) {
throw error;
  }
};

/**
 * Get participant list for a workshop
 * @param {string} workshopId - Workshop ID
 */
export const getParticipantsList = async (workshopId) => {
  const token =
    localStorage.getItem("authToken") || localStorage.getItem("token");

  if (!token) {
return;
  }

  try {
    const response = await fetch(`/api/workshops/${workshopId}/participants`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        `HTTP ${response.status}: ${data.message || "Unknown error"}`
      );
    }

    const participants = data.data?.participants || [];
participants.forEach((p, index) => {
});

    return participants;
  } catch (error) {
throw error;
  }
};

/**
 * 🚨 EMERGENCY: Diagnose organizer button issue
 * Run this in browser console on the workshops page
 */
export const diagnoseOrganizerIssue = () => {
// Get current user data
  const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
// Check if workshops are loaded in the page
  const workshopCards = document.querySelectorAll(".workshop-card");
// Try to find workshop data from React component state
  const reactFiber =
    workshopCards[0]?._reactInternalFiber ||
    workshopCards[0]?.__reactInternalInstance;
  if (reactFiber) {
}

  // Check localStorage for workshop data
  const cachedWorkshops = Object.keys(localStorage).filter((key) =>
    key.includes("workshop")
  );
return {
    currentUser,
    currentUserId: currentUser._id || currentUser.id,
    workshopCardsCount: workshopCards.length,
    hasReactFiber: !!reactFiber,
    cachedWorkshops,
  };
};

/**
 * 🧪 Test workshop API response directly
 */
export const testMainWorkshopAPI = async () => {
  const token =
    localStorage.getItem("authToken") || localStorage.getItem("token");
try {
    const response = await fetch("/api/workshops", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
if (data.data?.workshops?.length > 0) {
      const firstWorkshop = data.data.workshops[0];
const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
      const currentUserId = currentUser._id || currentUser.id;
      const organizerId =
        firstWorkshop.organizer?._id || firstWorkshop.organizer?.id;
}

    return data;
  } catch (error) {
return null;
  }
};

// Global test functions for browser console
if (typeof window !== "undefined") {
  window.workshopTestUtils = {
    testRemoveParticipant,
    testWorkshopUserRole,
    getParticipantsList,
    diagnoseOrganizerIssue, // ✅ NEW
    testMainWorkshopAPI, // ✅ NEW
  };
}
